import client from '../client';
import type { ApiResponse } from '../../types/api';

export interface RecentImage {
  filename: string;
  url: string;
  hash: string | null;
  source: 'product-preview' | 'product-attachment';
  productId?: string;
  productTitle?: string;
  createdAt?: string | null;
  description?: string;
  descriptionEn?: string;
  tags?: string[];
  colors?: string[];
}

export interface UploadedImage {
  filename: string;
  hash: string;
  url: string;
  bytes: number;
  mediaType: string;
}

export const uploadsApi = {
  recentImages: async (storeId: string, limit = 24) => {
    const res = await client.get<ApiResponse<{ images: RecentImage[] }>>(
      `/dashboard/${storeId}/uploads/recent-images`,
      { params: { limit } },
    );
    return res.data.data?.images ?? [];
  },

  uploadImage: async (storeId: string, base64: string) => {
    const res = await client.post<ApiResponse<UploadedImage>>(
      `/dashboard/${storeId}/uploads/image`,
      { base64 },
    );
    return res.data.data!;
  },
};
